import { createRegionsClient } from '@pay-roadrunner/regions-ui';
import { createTaxConfigurationClient, TaxConfigurationScreen } from '@pay-roadrunner/tax-configuration-ui';
import { authFetch } from '../auth/authFetch';
import { getApiBaseUrl } from '../auth/api';

const deps = { getBaseUrl: getApiBaseUrl, fetchImpl: authFetch };

export const TaxPage = () => <TaxConfigurationScreen
  regionsClient={createRegionsClient(deps)}
  taxConfigurationClient={createTaxConfigurationClient(deps)}
/>;
